import React, { useEffect, useState} from 'react';
import ProductsActions from 'actions/Product';
import ShelfFrequentProducts from "components/ShelfFrequentProducts";
import Loader from 'components/Loader';
import PubSub from 'services/PubSub/';
import ProductFactory from 'factories/Products';
import style from './style.scss'; //NOSONAR

const ProductsSimilar = ({skuId, categoryId, type, campaignData, categoryParent}) => {
    const [productSimilar, setSimilar] = useState(null);
    const [loading, setLoader] = useState(true);
    const [visibleText, setVisibleText] = useState(false);

    useEffect(() => {
        setLoader(true);
        if(skuId && campaignData){
            _getContent(skuId, categoryId, categoryParent)
        }
        
    }, [skuId, categoryId]);
    
    const _getContent = (_skuId, _categoryId, _categoryParent = null) => {
        ProductsActions.getRecommended(false,_skuId, campaignData && campaignData.campaign, campaignData && campaignData.filter, type, _categoryId).then((response) => {
            if (response && response.length > 1 ) {
                const produtcsFilter = response.filter((_product) => ProductFactory.hasStock(_product.items ? _product.items[0] : null));
                if(produtcsFilter.length){
                    setSimilar(produtcsFilter);

                    if(!_categoryParent && categoryParent){
                        setVisibleText(true)
                    } else {
                        setVisibleText(false)
                    }

                } else {
                    __getContent(_skuId, _categoryParent)
                }

            } else {
                __getContent(_skuId, _categoryParent)
            }
            
            setLoader(false);
        });
    }

    const __getContent = (_skuId, _categoryParent) => {
        if(_categoryParent){
            _getContent(_skuId, _categoryParent)
        }else{
            _close();
        }
    }

    const _close = () => {
        PubSub.dispatch('drawer_similar_products_close');
    }

    return (
        <div className={'drawer-container'}>
            <h1 className="drawer-title">Productos Similares</h1>
            <div className={'drawer-scroll'}>
                {visibleText && <span className="drawer-subtitle-similar">No encontramos productos iguales al que buscas, pero te recomendamos otros de la misma categoría: </span>}
                {loading && <div className='drawer-loader'><Loader/></div>}
                {!loading && productSimilar && productSimilar.length &&<ShelfFrequentProducts products={productSimilar} list={'Productos Similares PLP'} withOutUrl={true} /> }
            </div>
            <div className="drawer-actions">
                <button type="button" className="primary-btn" onClick={_close} >Volver</button>
            </div>
        </div>
   
    );
}

export default ProductsSimilar;